import { Link } from "gatsby"

const TranslationLink = ({ linkUrl, onClick, linkText, target }) => {
  const isExternalSite =
    linkUrl.startsWith("https://") || linkUrl.startsWith("http://")
  return isExternalSite ? (
    <a
      href={linkUrl}
      onClick={(event) => onClick(event, linkUrl)}
      target={target}
      className="underline"
    >
      {linkText}
    </a>
  ) : (
    <Link href={linkUrl} className="underline">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <a onClick={(event) => onClick(event, linkUrl)} target={target}>
        {linkText}
      </a>
    </Link>
  )
}

export const handleLinks = (str, elements = [], opts = {}) => {
  const linkRegExpMatch = /\[([^\]]*)\]\(([^)]*)\)/g.exec(str)
  if (!linkRegExpMatch) {
    return [...elements, str]
  }
  const { target = "_self", onClick = () => {} } = opts
  const {
    index: matchIndex,
    0: match,
    1: linkText,
    2: linkUrl,
  } = linkRegExpMatch
  const textBeforeLink = str.substring(0, matchIndex)

  const element = (
    <span key={matchIndex + linkUrl + linkText}>
      {textBeforeLink}
      <TranslationLink
        linkUrl={linkUrl}
        linkText={linkText}
        target={target}
        onClick={(event, url) => onClick(event, url)}
      />
    </span>
  )

  const textAfterMatch = str.substring(matchIndex + match.length, str.length)
  return handleLinks(textAfterMatch, [...elements, element], opts)
}
